import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loading: false,
  medications: [],
  count: 0,
  ocrResult: null,
};

export const medicationState = createSlice({
  name: "medications",
  initialState,
  reducers: {
    setLoading(state, action) {
      return {
        ...state,
        loading: action?.payload
      };
    },

    setMedications(state, action) {
     
      return {
        ...state,
        loading: false,
        medications: action?.payload?.medications,
        
        count: action?.payload?.count,
      };
    },

    setOcrResult(state, action) {
      return { ...state, ocrResult: action.payload };
    },

    clearOcrResult(state) {
      return { ...state, ocrResult: null };
    },

    // Reset State
    reset() {
      return initialState;
    }
  }
});

export const { setLoading, setMedications, setOcrResult, clearOcrResult } = medicationState.actions;
export default medicationState.reducer;
